module.exports = __webpack_public_path__ + "static/media/andamento.d77da868.png";